import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'despesa/cadastro/compra', ptBr);
i18next.addResourceBundle('en', 'despesa/cadastro/compra', en);

const CompraConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/suprimentos/compra',
      component: React.lazy(() => import('./Compra')),
    },
  ],
};

export default CompraConfig;
